import { MarkerType } from '../types';

export interface MapFiltersProps {
  markerTypes: MarkerType[];
  selectedMarkerTypes: MarkerType[];
  setSelectedMarkerTypes: (markerTypes: MarkerType[]) => void;
  onFilterChange: (markerTypes: MarkerType[]) => void;
}
